module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA6.10035162.jpg";